import { Alert, Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useSearchParams } from "react-router-dom";

export function MagicLinkSent() {
  const [params] = useSearchParams();
  const email = params.get("email");

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Check your email
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            We sent you a sign-in link{email ? ` to ${email}` : ""}.
          </Typography>
        </Box>

        <Paper elevation={0} sx={{ p: 3, border: "1px solid", borderColor: "divider" }}>
          <Stack spacing={2}>
            <Alert severity="info">
              Open the email and click the link to sign in. The link may expire after a short time.
            </Alert>
            <Button component={RouterLink} to="/login" variant="contained" size="large">
              Back to sign in
            </Button>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
}

